import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '../../../../tool'
import PropTypes from 'prop-types'
import { modelUtils } from '@/utils'
let { WizContainer } = framework_tool
let {
    WizSelect,
    WizModal,
    WizTreeSelectList,
} = component_tool

class ExamCategorySelect extends WizContainer {

    componentName = 'ExamCategorySelect'

    constructor(props) {
        super(props)
        this.state = {
            value: props.value,
            modalVisible: false,
            selects: props.selects
        }
    }

    static propTypes = {
        value: PropTypes.array,
        apiParams: PropTypes.object,
        onChange: PropTypes.func,
        onChangeRowMap: PropTypes.func, //确认数据集回调方法（参数为{ rowKey: row }）
        checkable: PropTypes.bool,
        disabled: PropTypes.bool,
    }

    static defaultProps = {
        value: undefined,
        apiParams: {},
        checkable: false,
        disabled: false,
    }

    _searchTreeData() {
        this.doAction({
            path: 'categoryType/nodeList',
            payload: {
                key: 'categoryType_examination',
                apiParams: { type: 0, state: 1, ...this.props.apiParams }
            }
        })
    }

    propsAndStateOnChange = {
        value: this._valueOnChange.bind(this),
        treeData: this._treeDataOnChange.bind(this)
    }

    _valueOnChange(nextProps, nextState) {
        if (nextProps.value !== this.props.value) {
            nextState.value = nextProps.value
            return true
        }
        return false
    }

    _treeDataOnChange(nextProps, nextState) {
        if (nextProps.treeData.code === 1) {
            nextProps.treeData.data && nextProps.treeData.data.length && nextProps.treeData.data.forEach(data => {
                this._formatData(data)
            })
        }
        return true
    }

    _formatData(data) {
        data.key = data.value
        data.children && data.children.length && data.children.forEach(c => {
            this._formatData(c)
        })
    }

    _renderOptions(data) {
        let options = []
        data && data.length && data.forEach(row => {
            options.push(this._renderOption(row))
        })
        return options
    }

    _renderOption(row) {
        if (row) {
            return (
                <WizSelect.Option key={row.key} value={row.key} title={row.title}>
                    {row.title}
                </WizSelect.Option>
            )
        }
    }

    _renderValue() {
        if (this.props.renderValue) {
            return this.props.renderValue()
        } else {
            return (
                <div onClick={() => !this.props.disabled && this.setState({ modalVisible: true }, () => this._searchTreeData())}>
                    <WizSelect
                        value={this.state.value || undefined}
                        open={false}
                        disabled={this.props.disabled}
                        placeholder={'请选择考试分类'}
                    >
                        {this._renderOptions(this.state.selects)}
                    </WizSelect>
                </div>
            )
        }
    }

    _wizSelectOnSubmit() {
        this.setState({ modalVisible: false, value: this.state.selects.map(select => select.key)[0] }, () => {
            this.props.onChange && this.props.onChange(this.state.value)
            this.props.onChangeRowMap && this.props.onChangeRowMap(this.state.selects.map(select => select)[0])
        })
    }

    _renderModal() {
        let checkedKeys = this.state.selects.map(select => select.key)
        let treeData = this.props.treeData.data
        return (
            <WizModal
                visible={this.state.modalVisible}
                title={'选择考试分类'}
                width={1000}
                onOk={e => this._wizSelectOnSubmit()}
                onCancel={e => this.setState({ modalVisible: false })}
            >
                <WizTreeSelectList
                    treeProps={{ checkStrictly: true }}
                    treeData={treeData}
                    // checkType='child'
                    checkedKeys={checkedKeys}
                    checkable={this.props.checkable}
                    listCheck={this.state.selects}
                    itemProps={{
                        icon: 'unordered-list',
                        title: '考试分类',
                        tips: '请选择考试分类'
                    }}
                    onChange={(selects) => this.setState({ selects })}
                />
            </WizModal>
        )
    }

    _render() {
        return (
            <>
                {this._renderValue()}
                {this._renderModal()}
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { categoryType } = state
    const treeData = modelUtils.getModelEntity(categoryType, 'categoryType_examination')
    const load = modelUtils.getLoadingState(state, 'categoryType')
    return {
        treeData,
        ...load
    }
}
export default connect(mapStateToProps)(ExamCategorySelect)

